var _g, _g2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#818487",
    d: "M-39.55,24.647h-4.275c-0.485,0-0.879-0.393-0.879-0.879c0-0.485,0.393-0.879,0.879-0.879 h4.275c0.485,0,0.879,0.393,0.879,0.879C-38.671,24.253-39.064,24.647-39.55,24.647z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#818487",
    d: "M-41.551,27.522h-2.274c-0.485,0-0.879-0.393-0.879-0.879 c0-0.485,0.393-0.879,0.879-0.879h2.274c0.485,0,0.879,0.393,0.879,0.879C-40.672,27.129-41.065,27.522-41.551,27.522z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.061,12l3.532-3.532c0.293-0.293,0.293-0.768,0-1.061s-0.768-0.293-1.061,0L12,10.939L8.468,7.407 c-0.293-0.293-0.768-0.293-1.061,0s-0.293,0.768,0,1.061L10.939,12l-3.532,3.532c-0.293,0.293-0.293,0.768,0,1.061 c0.146,0.146,0.338,0.22,0.53,0.22s0.384-0.073,0.53-0.22L12,13.061l3.532,3.532c0.146,0.146,0.338,0.22,0.53,0.22 s0.384-0.073,0.53-0.22c0.293-0.293,0.293-0.768,0-1.061L13.061,12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.0aa07e6610ea831ba42893548fb0fec5.svg";
export { ForwardRef as ReactComponent };